<script lang="ts" setup>
onMounted(() => {
  if (document) {
    const removeAttributes = (selectors: string[], attributes: string[]) => {
      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((item) => {
          attributes.forEach((attr) => item?.removeAttribute(attr))
        })
      })
    }
    removeAttributes(
      ['[aria-haspopup="menu"]'],
      ['aria-haspopup', 'aria-owns', 'aria-expanded']
    )

    removeAttributes(
      ['[role="listbox"]', '[role="separator"]'],
      ['role']
    )
  }
})

useHead({
  link: [
    {
      rel: 'preload',
      as: 'image',
      href: '/images/sports/redborder.webp',
    },
    {
      rel: 'preload',
      as: 'image',
      href: '/images/logo/logo.svg',
    },
    {
      rel: 'preload',
      as: 'image',
      href: '/images/event-drawing-lots/popup.webp',
    },
  ],
})
</script>

<template>
  <div class="home-page container">
    <div class="section-banner">
      <DesktopHomeHeroBanner />
      <DesktopHomeHotmatch />
    </div>
    <DesktopHomeTopJackpot />
    <DesktopHomeGameCategories />
    <DesktopHomePopularSection />
    <DesktopHomeGameBaiSection />
    <CommonCasinoLivestream />
    <DesktopHomeLiveCasinoSection />
    <div class="section-promotion">
      <DesktopHomePromotion title="Khuyến mãi" icon="icon-promotion" />
    </div>
    <DesktopHomeTopWinnerSection />
  </div>
</template>
<style scoped lang="scss">
@import '~/assets/styles/components/desktop/home/index.scss';
</style>
